

























import VFormControl from "@/components/UI/VFormControl.vue";
import { mapMutations } from "vuex";
import Papa from "papaparse";
import { BarLoader } from "@saeris/vue-spinners";
import Vue from "vue";
import { AssignBody, GenericOutcome} from "@/util/commonTypes";
import { assignMultiple } from "@/services/assign";
import { WithLoading } from "@/util/componentTypes";

interface ComponentState extends WithLoading {
  multipleData: AssignBody[];
}

export default Vue.extend({
  name: "VSignOutMultiple",
  components: { VFormControl, BarLoader },
  data(): ComponentState {
    return {
      multipleData: [],
      loading: false
    };
  },
  methods: {
    ...mapMutations(["clearSearchResults"]),
    onChangeFile(e): void {
      Papa.parse(e.target.files[0], {
        complete: (results: { data: AssignBody[] }): void => {
          // noinspection JSIncompatibleTypesComparison
          if (results.data[0].number === undefined || results.data[0].location === undefined) {
            this.$toasted.error("Error: Invalid CSV file", { duration: 2000 });
            return;
          }
          this.multipleData = results.data.filter(item => item.number && item.number.length > 3 && item.location && item.location.length > 0);
        },
        header: true,
        skipEmptyLines: true
      });
    },
    async onSubmit() {
      this.loading = true;
      const [outcome, result] = await assignMultiple(this.multipleData);
      this.loading = false;
      switch (outcome) {
        case GenericOutcome.Ok:
          this.$toasted.success(`Signed out ${result}`, { duration: 5000 });
          this.clearSearchResults();
          break;
        case GenericOutcome.Err:
          this.$toasted.error(`Error: ${result}`, {duration: 2000});
          break;
        default:
          console.error(outcome, result)
          this.$toasted.show("Something went wrong", {duration: 1000})
      }
    }
  }
});
